import { render, staticRenderFns } from "./BaseTextareaWithProvider.vue?vue&type=template&id=1ead2c34&scoped=true&"
import script from "./BaseTextareaWithProvider.vue?vue&type=script&lang=js&"
export * from "./BaseTextareaWithProvider.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextareaWithProvider.vue?vue&type=style&index=0&id=1ead2c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ead2c34",
  null
  
)

export default component.exports